var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleLock2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58333 8.95573V6.8724C4.58333 3.99591 6.91518 1.66406 9.79167 1.66406C12.6681 1.66406 15 3.99591 15 6.8724V8.95573C16.1506 8.95573 17.0833 9.88847 17.0833 11.0391V16.2474C17.0833 17.398 16.1506 18.3307 15 18.3307H4.58333C3.43274 18.3307 2.5 17.398 2.5 16.2474V11.0391C2.5 9.88847 3.43274 8.95573 4.58333 8.95573ZM12.9167 6.8724V8.95573H6.66667V6.8724C6.66667 5.14651 8.06578 3.7474 9.79167 3.7474C11.5176 3.7474 12.9167 5.14651 12.9167 6.8724Z",
    fill: "#823FC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLock2);
export default __webpack_public_path__ + "static/media/purple-lock-2.b858f5c8057d2845e9de31404bc979ad.svg";
export { ForwardRef as ReactComponent };